import { render, staticRenderFns } from "./CompanyDimensionEditor.vue?vue&type=template&id=23c3ee5d&scoped=true"
import script from "./CompanyDimensionEditor.vue?vue&type=script&lang=js"
export * from "./CompanyDimensionEditor.vue?vue&type=script&lang=js"
import style0 from "./CompanyDimensionEditor.vue?vue&type=style&index=0&id=23c3ee5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3ee5d",
  null
  
)

export default component.exports